<template>
   <b-card title="Helpdesk x Jenis Pekerjaan">
        <app-echart-bar
          :option-data="dataOptionChart"
        />
      </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BCardSubTitle,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import flatPickr from 'vue-flatpickr-component'
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'

export default {
  components: {
    // BRow,
    // BCol,
    BCard,
    AppEchartBar,
    // BCardHeader,
    // BCardSubTitle,
    // BCardTitle,
    // BCardText,
    // BCardBody,
    // BMedia,
    // BAvatar,
    // BMediaAside,
    // BMediaBody,
    // VueApexCharts,
    // flatPickr,
  },
  props: {
    dataOptionChart: {},
  },
}
</script>
